(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drbell-styles"] && !Shopify.designMode) return;
  try {
    (() => {
  const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: 0.12 });
  const scan = () => document.querySelectorAll('.db .reveal:not(.in)').forEach((n) => io.observe(n));
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
  } catch(e) { console.error(e); }
})();

})();
